// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "../../../../../../node_modules/rescript/lib/es6/caml.js";
import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Weekday from "../types/common/Weekday.bs.js";
import * as Json_decode from "../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as CampaignStatus from "../types/surge/CampaignStatus.bs.js";
import * as DateTime$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function decodeGeoRegion(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("name", Json_decode.string, json)
        };
}

function decodeSurgeStrategy(json) {
  var name = Json_decode.field("enum_code", Json_decode.string, json);
  switch (name) {
    case "flat" :
        return {
                TAG: /* Flat */0,
                _0: Json_decode.field("amount", Json_decode.$$int, json)
              };
    case "multiplier" :
        return {
                TAG: /* Multiplier */1,
                _0: Json_decode.field("multiplier", Json_decode.$$float, json)
              };
    default:
      return ErrorUtils$Catalyst.raiseError("SurgeStateMapper.re", "Invalid 'enum_code' ", name);
  }
}

function decodeAdministrator(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          email: Json_decode.field("email", Json_decode.string, json)
        };
}

function decodeVehicleType(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("display_name", Json_decode.string, json)
        };
}

function decodeZone(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          description: Json_decode.field("description", Json_decode.string, json)
        };
}

function convertToWeekdays(weekdays) {
  return List.sort(Caml.caml_int_compare, List.map(Weekday.fromString, weekdays));
}

function decodeCampign(json) {
  return {
          campaignId: Json_decode.field("id", Json_decode.$$int, json),
          campaignName: Json_decode.field("campaign_name", Json_decode.string, json),
          geoRegionDetail: Json_decode.field("geo_region", decodeGeoRegion, json),
          vehicleTypeDetail: Json_decode.field("vehicle_types", (function (param) {
                  return Json_decode.list(decodeVehicleType, param);
                }), json),
          surgeStrategy: Json_decode.field("surge_strategy", decodeSurgeStrategy, json),
          campaignStartDate: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("campaign_start_date", Json_decode.string, json)),
          campaignEndDate: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("campaign_end_date", Json_decode.string, json)),
          weekdays: convertToWeekdays(Json_decode.field("weekdays", (function (param) {
                      return Json_decode.list(Json_decode.string, param);
                    }), json)),
          windowStartMins: Json_decode.field("window_start_mins", Json_decode.$$int, json),
          windowEndMins: Json_decode.field("window_end_mins", Json_decode.$$int, json),
          administratorDetail: Json_decode.field("administrator", decodeAdministrator, json),
          status: CampaignStatus.fromString(Json_decode.field("status", Json_decode.string, json)),
          priority: Json_decode.field("priority", Json_decode.$$int, json),
          zones: Json_decode.optional((function (param) {
                  return Json_decode.field("zones", (function (param) {
                                return Json_decode.list(decodeZone, param);
                              }), param);
                }), json)
        };
}

function builder(json) {
  return Json_decode.field("campaigns", (function (param) {
                return Json_decode.list(decodeCampign, param);
              }), json);
}

var Campaigns = {
  decodeGeoRegion: decodeGeoRegion,
  decodeSurgeStrategy: decodeSurgeStrategy,
  decodeAdministrator: decodeAdministrator,
  decodeVehicleType: decodeVehicleType,
  decodeZone: decodeZone,
  convertToWeekdays: convertToWeekdays,
  decodeCampign: decodeCampign,
  builder: builder
};

function decodeGeoregion(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("name", Json_decode.string, json)
        };
}

function builder$1(json) {
  return Json_decode.field("geo_regions", (function (param) {
                return Json_decode.list(decodeGeoregion, param);
              }), json);
}

var GeoRegions = {
  decodeGeoregion: decodeGeoregion,
  builder: builder$1
};

function decodeVehicleTypes(json) {
  return {
          id: Json_decode.field("vehicle_id", Json_decode.$$int, json),
          name: Json_decode.field("name", Json_decode.string, json)
        };
}

function builder$2(json) {
  return Json_decode.field("vehicle_types", (function (param) {
                return Json_decode.list(decodeVehicleTypes, param);
              }), json);
}

var VehicleTypes = {
  decodeVehicleTypes: decodeVehicleTypes,
  builder: builder$2
};

function decodeZones(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          description: Json_decode.field("description", Json_decode.string, json)
        };
}

function builder$3(json) {
  return Json_decode.field("zones", (function (param) {
                return Json_decode.list(decodeZones, param);
              }), json);
}

var Zones = {
  decodeZones: decodeZones,
  builder: builder$3
};

function execute(_json) {
  return {
          title: "Deactivate Campaign",
          message: "Campaign successfully deactivated"
        };
}

var DisableCampaign = {
  execute: execute
};

function execute$1(_json) {
  return {
          title: "Create Campaign",
          message: "Campaign successfully created"
        };
}

var CreateCampiagn = {
  execute: execute$1
};

export {
  Campaigns ,
  GeoRegions ,
  VehicleTypes ,
  Zones ,
  DisableCampaign ,
  CreateCampiagn ,
  
}
/* DateTime-Catalyst Not a pure module */
